import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/addImage.svg'
import _imports_1 from '@/assets/editImage.svg'
import _imports_2 from '@/assets/rightArrowFilled.svg'
import _imports_3 from '@/assets/downArrow.svg'
import _imports_4 from '@/assets/externalLink.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-e3536244"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "flex items-center justify-center w-full h-full skeleton mt-4 tableCornerRadius bg-white" }
const _hoisted_3 = {
  key: 1,
  class: "pt-3 pl-5 pr-5"
}
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Courses")
], -1))
const _hoisted_6 = { class: "w-full pt-3" }
const _hoisted_7 = { class: "bg-white border border-lightgrey pt-3 px-5 pb-5 rounded" }
const _hoisted_8 = { class: "header flex justify-between" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "switch" }
const _hoisted_13 = { class: "switch" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_15 = { class: "coursecontainer" }
const _hoisted_16 = { class: "row flex flex-wrap w-full pt-3" }
const _hoisted_17 = { class: "col-md-6 w-3/6 pr-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1 text-black" }, "Name", -1))
const _hoisted_19 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_20 = {
  key: 0,
  class: "error-text"
}
const _hoisted_21 = { class: "col-md-6 w-3/6 pl-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1 text-black" }, "Type", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  hidden: "",
  selected: ""
}, "Please select type", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 10601 }, "Mandatory", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 10602 }, "Optional", -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "error-text"
}
const _hoisted_29 = { class: "row flex flex-wrap w-full pt-3" }
const _hoisted_30 = { class: "col-md-12 w-full" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1 text-black" }, "Description", -1))
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text"
}
const _hoisted_34 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_35 = { class: "row flex flex-wrap w-full pt-3 cursor-pointer" }
const _hoisted_36 = { class: "col-md-12 w-full cursor-pointer" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1 text-black" }, "Image", -1))
const _hoisted_38 = { class: "mt-2" }
const _hoisted_39 = { htmlFor: "upload" }
const _hoisted_40 = { class: "flex inputboxstylingforAddImage mt-2 justify-center items-center cursor-pointer border rounded py-2 border-lightgrey" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("label", { htmlFor: "upload" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "w-52 h-32 cursor-pointer"
    })
  ])
], -1))
const _hoisted_43 = { class: "flex justify-center items-center mt-2" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "text-sm font-bold" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("label", { htmlFor: "upload" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "",
      class: "w-52 h-32 cursor-pointer"
    })
  ])
], -1))
const _hoisted_48 = { class: "flex justify-center items-center mt-2" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "text-sm font-bold" }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { class: "flex justify-center flex-col mt-px" }
const _hoisted_53 = { class: "flex justify-center" }
const _hoisted_54 = {
  key: 0,
  htmlFor: "upload"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { htmlFor: "upload" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "-mt-10 flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1 font-semibold text-xs cursor-pointer" }, "Edit Image")
  ])
], -1))
const _hoisted_57 = {
  key: 0,
  class: "flex justify-center items-center mt-2"
}
const _hoisted_58 = { class: "text-sm font-bold" }
const _hoisted_59 = { class: "flex justify-center" }
const _hoisted_60 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_63 = {
  key: 1,
  class: "flex justify-center items-center ml-6"
}
const _hoisted_64 = { class: "pt-3" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "w-full flex items-center" }
const _hoisted_67 = { class: "w-2 flex items-center" }
const _hoisted_68 = {
  key: 0,
  src: _imports_2,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_69 = {
  key: 1,
  src: _imports_3,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_70 = { class: "heading font-opensans flex justify-between items-center text-sm w-98 pl-1" }
const _hoisted_71 = { class: "mr-1" }
const _hoisted_72 = {
  key: 0,
  class: "rounded-full w-5 h-5 bg-green mx-auto"
}
const _hoisted_73 = {
  key: 1,
  class: "rounded-full w-5 h-5 bg-error mx-auto"
}
const _hoisted_74 = {
  key: 0,
  class: "accordion-body bg-white"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-b border-solid border-lightgrey mt-2" }, null, -1))
const _hoisted_76 = ["id"]
const _hoisted_77 = { class: "row flex flex-wrap w-full" }
const _hoisted_78 = { class: "row flex w-full" }
const _hoisted_79 = { class: "w-full pl-2 pt-3" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Module Name", -1))
const _hoisted_81 = ["id", "onUpdate:modelValue"]
const _hoisted_82 = { key: 0 }
const _hoisted_83 = {
  key: 0,
  class: "error-text text-red-500"
}
const _hoisted_84 = {
  key: 1,
  class: "error-text text-red-500"
}
const _hoisted_85 = { class: "flex justify-end items-end px-3" }
const _hoisted_86 = { class: "switch" }
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_89 = { class: "col-md-6 w-full p-2.5" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Module Description", -1))
const _hoisted_91 = ["id", "onUpdate:modelValue"]
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  key: 0,
  class: "error-text text-red-500"
}
const _hoisted_94 = { class: "row flex flex-wrap w-full" }
const _hoisted_95 = { class: "col-md-12 w-full p-2.5" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-xs mb-1" }, "Image", -1))
const _hoisted_97 = { class: "mt-2" }
const _hoisted_98 = ["htmlFor"]
const _hoisted_99 = ["id", "onChange"]
const _hoisted_100 = { class: "flex inputboxstylingforAddImage justify-center mt-2 items-center cursor-pointer border rounded py-2 border-lightgrey" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = ["htmlFor"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-52 h-32 cursor-pointer"
}, null, -1))
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = { class: "flex justify-center items-center mt-2" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "text-sm font-bold" }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = ["htmlFor"]
const _hoisted_110 = ["src"]
const _hoisted_111 = ["htmlFor"]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "-mt-10 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "borderstyle p-1 font-semibold text-xs cursor-pointer" }, "Edit Image")
], -1))
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "flex justify-center items-center mt-4" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "text-sm font-bold" }
const _hoisted_117 = { class: "p-2.5" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = { class: "actionicon" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = { class: "accordion-body bg-white" }
const _hoisted_124 = {
  key: 0,
  class: "p-2"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1))
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { class: "flex justify-between bg-white py-2.5 px-2 text-sm rounded" }
const _hoisted_128 = {
  key: 1,
  class: "flex justify-between bg-white py-2.5 px-2"
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-black" }, "Please Add Screens", -1))
const _hoisted_130 = [
  _hoisted_129
]
const _hoisted_131 = ["onClick"]
const _hoisted_132 = { class: "actionicon" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-5 w-5"
}, null, -1))
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = {
  key: 0,
  class: "accordion-body bg-white p-2"
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1))
const _hoisted_138 = { class: "mt-2" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = { class: "flex justify-between bg-white py-2.5 px-2 text-sm rounded" }
const _hoisted_141 = {
  key: 1,
  class: "flex justify-between bg-white py-2.5 px-2 text-black"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Please Add Questions", -1))
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = { class: "flex justify-center p-4" }
const _hoisted_145 = { class: "flex justify-center items-center" }
const _hoisted_146 = ["onClick"]
const _hoisted_147 = {
  key: 0,
  class: "flex justify-center items-center ml-6"
}
const _hoisted_148 = ["onClick"]
const _hoisted_149 = {
  key: 1,
  class: "buttonposition flex justify-center items-center ml-6"
}
const _hoisted_150 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.dataLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_dots_loader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.myValueId)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_10, "Add Course"))
                    : (_openBlock(), _createElementBlock("h1", _hoisted_11, "Edit Course"))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.courses[0].isActive) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.courses[0].isActive]
                    ]),
                    _hoisted_14
                  ])
                ])
              ]),
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["inputboxstyling mt-2", {
											'is-invalid': _ctx.v$.courses[0].courseName.$error
										}]),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.courses[0].courseName) = $event)),
                        placeholder: "Name"
                      }, null, 2), [
                        [_vModelText, _ctx.courses[0].courseName]
                      ]),
                      (_ctx.v$.courses[0].courseName.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_ctx.v$.courses[0].courseName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["inputboxstyling mt-2", {
											'is-invalid': _ctx.v$.courses[0].courseType.$error
										}]),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.courses[0].courseType) = $event))
                      }, _hoisted_26, 2), [
                        [_vModelSelect, _ctx.courses[0].courseType]
                      ]),
                      (_ctx.v$.courses[0].courseType.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (_ctx.v$.courses[0].courseType.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "4",
                        cols: "50",
                        type: "text",
                        class: _normalizeClass(["inputboxstyling mt-2", {
											'is-invalid': _ctx.v$.courses[0].courseDescription.$error
										}]),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.courses[0].courseDescription) = $event)),
                        placeholder: "Description"
                      }, null, 2), [
                        [_vModelText, _ctx.courses[0].courseDescription]
                      ]),
                      (_ctx.v$.courses[0].courseDescription.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_ctx.v$.courses[0].courseDescription.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Required"))
                              : _createCommentVNode("", true),
                            (_ctx.v$.courses[0].courseDescription.maxLengthValue.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Characters should not more than 308"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("label", _hoisted_39, [
                          _createElementVNode("input", {
                            type: "file",
                            id: "upload",
                            style: {"display":"none"},
                            ref: "fileInput",
                            onChange: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.checkFile()), ["stop"]))
                          }, null, 544)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", null, [
                          (!_ctx.courses[0].courseImageUrl && _ctx.pageType=='add')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _hoisted_42,
                                _createElementVNode("div", _hoisted_43, [
                                  (_ctx.fileName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createTextVNode(" Selected File: "),
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.fileName), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (!_ctx.courses[0].courseImageUrl && _ctx.pageType=='edit')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, [
                                    (_ctx.fileName)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                          _createTextVNode(" Selected File: "),
                                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.fileName), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      (_ctx.courses[0].courseImageUrl != undefined)
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_54, [
                                            _createElementVNode("img", {
                                              src: _ctx.courses[0].courseImageUrl,
                                              alt: "",
                                              class: "w-96 h-52 cursor-pointer"
                                            }, null, 8, _hoisted_55)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _hoisted_56,
                                    _createElementVNode("div", null, [
                                      (_ctx.fileName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                            _createTextVNode(" Selected File: "),
                                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.fileName), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                (_ctx.myValueId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("button", {
                        class: "btnprimary mt-4",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addModule()))
                      }, "Add Module")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (!_ctx.myValueId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        (_ctx.coursemodule)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["mt-4", !_ctx.allEmptyValues || _ctx.fileName!=''?'btnprimary':'btndisabled pointer-events-none']),
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addCourse()))
                              }, "Create Course", 2)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("button", {
                          class: _normalizeClass([(JSON.stringify(this.dummyData) !== JSON.stringify(this.courses[0])) || !this.fileStatusName ?'btnprimary' : 'btndisabled pointer-events-none', "mt-4"]),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSingleCourse()))
                        }, "Update Course", 2)
                      ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (singlemodule, smIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["text-black no-underline mt-3 cursor-pointer", { 'accordion': singlemodule.moduleToggle }]),
                  key: singlemodule._id
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex bg-white py-2.5 px-2.5 rounded", { 'accordion-head': !singlemodule.moduleToggle }]),
                    onClick: ($event: any) => (_ctx.toggleModuleContainer(singlemodule,smIndex))
                  }, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        (!singlemodule.moduleToggle)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_68))
                          : (_openBlock(), _createElementBlock("img", _hoisted_69))
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", null, _toDisplayString(singlemodule.moduleName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      (_ctx.modules[smIndex].isModuleActive == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72))
                        : (_openBlock(), _createElementBlock("div", _hoisted_73))
                    ])
                  ], 10, _hoisted_65),
                  (singlemodule.moduleToggle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("form", {
                          id: 'module'+smIndex
                        }, [
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("div", _hoisted_79, [
                                _hoisted_80,
                                _withDirectives(_createElementVNode("input", {
                                  id: smIndex,
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
													'is-invalid': (_ctx.v$.modules.$error && !_ctx.v$.modules.$each.$response.$data[smIndex].moduleName.required) ||(singlemodule.validationModuleName)
												}]),
                                  "onUpdate:modelValue": ($event: any) => ((singlemodule.moduleName) = $event),
                                  placeholder: "ModuleName"
                                }, null, 10, _hoisted_81), [
                                  [_vModelText, singlemodule.moduleName]
                                ]),
                                (_ctx.v$.modules.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                      (!_ctx.v$.modules.$each.$response.$data[smIndex].moduleName.required)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (singlemodule.validationModuleName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, "Same Module Name Exists"))
                                    : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("label", _hoisted_86, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.modules[smIndex].isModuleActive) = $event)
                                  }, null, 8, _hoisted_87), [
                                    [_vModelCheckbox, _ctx.modules[smIndex].isModuleActive]
                                  ]),
                                  _hoisted_88
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _hoisted_90,
                              _withDirectives(_createElementVNode("input", {
                                id: smIndex,
                                type: "text",
                                class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.modules.$error && !_ctx.v$.modules.$each.$response.$data[smIndex].moduleDescriptions.required
											}]),
                                "onUpdate:modelValue": ($event: any) => ((singlemodule.moduleDescriptions) = $event),
                                placeholder: "ModuleDescription"
                              }, null, 10, _hoisted_91), [
                                [_vModelText, singlemodule.moduleDescriptions]
                              ]),
                              (_ctx.v$.modules.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                    (!_ctx.v$.modules.$each.$response.$data[smIndex].moduleDescriptions.required)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("div", _hoisted_95, [
                                _hoisted_96,
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("label", {
                                    htmlFor: 'uploadImage'+ smIndex
                                  }, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      id: 'uploadImage'+ smIndex,
                                      style: {"display":"none"},
                                      ref_for: true,
                                      ref: 'element' + smIndex,
                                      onChange: _withModifiers(($event: any) => (_ctx.checkFile(smIndex)), ["stop"])
                                    }, null, 40, _hoisted_99)
                                  ], 8, _hoisted_98)
                                ]),
                                _createElementVNode("div", _hoisted_100, [
                                  _createElementVNode("div", null, [
                                    (!singlemodule.imageUrl && (_ctx.pageType=='add'||_ctx.pageType=='edit'))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("label", {
                                              htmlFor: 'uploadImage'+ smIndex,
                                              class: "flex justify-center mt-2"
                                            }, _hoisted_104, 8, _hoisted_102)
                                          ]),
                                          _createElementVNode("div", _hoisted_105, [
                                            (_ctx.fileNameMod[smIndex])
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                  _createTextVNode("Selected File : "),
                                                  _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.fileNameMod[smIndex]), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("label", {
                                              htmlFor: 'uploadImage'+ smIndex,
                                              class: "flex justify-center mt-0.5"
                                            }, [
                                              _createElementVNode("img", {
                                                src: singlemodule.imageUrl,
                                                alt: "upload",
                                                class: "w-96 h-52 cursor-pointer"
                                              }, null, 8, _hoisted_110)
                                            ], 8, _hoisted_109)
                                          ]),
                                          _createElementVNode("label", {
                                            htmlFor: 'uploadImage'+ smIndex
                                          }, _hoisted_113, 8, _hoisted_111),
                                          _createElementVNode("div", _hoisted_114, [
                                            (_ctx.fileNameMod[smIndex])
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                  _createTextVNode("Selected File : "),
                                                  _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.fileNameMod[smIndex]), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_117, [
                            (singlemodule._id)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["text-black no-underline mt-6 min-h-30", { accordion: _ctx.visibilityscreens }])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex justify-between bg-white py-2.5 px-2 rounded", { 'accordion-head': !_ctx.visibilityscreens }])
                                  }, [
                                    _createElementVNode("div", {
                                      class: "heading w-11/12 text-sm content-center",
                                      onClick: ($event: any) => (_ctx.getallScreens(singlemodule))
                                    }, "Screens", 8, _hoisted_118),
                                    _createElementVNode("div", _hoisted_119, [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.addScreen(smIndex)),
                                        class: "p-1 text-greys cursor-pointer"
                                      }, _hoisted_122, 8, _hoisted_120)
                                    ])
                                  ], 2),
                                  _createElementVNode("div", _hoisted_123, [
                                    (_ctx.visibilityscreens)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                          _hoisted_125,
                                          (singlemodule.screensArray)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlemodule.screensArray, (screen) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "accordion-head text-black no-underline mt-3 min-h-3",
                                                    key: screen,
                                                    id: "screendata"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_127, _toDisplayString(screen.screenName), 1)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_128, _hoisted_130))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2))
                              : _createCommentVNode("", true),
                            (singlemodule._id)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass(["text-black no-underline min-h-30 mt-2", { accordion: _ctx.visibilityQuestionaire }])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex justify-between bg-white py-2.5 px-2 rounded", { 'accordion-head': !_ctx.visibilityQuestionaire }])
                                  }, [
                                    _createElementVNode("div", {
                                      class: "heading w-11/12 text-sm content-center",
                                      onClick: ($event: any) => (_ctx.getallQuestionaireScreens(singlemodule))
                                    }, "Questionaire", 8, _hoisted_131),
                                    _createElementVNode("div", _hoisted_132, [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.addQuestionaire(smIndex)),
                                        class: "p-1 text-greys cursor-pointer"
                                      }, _hoisted_135, 8, _hoisted_133)
                                    ])
                                  ], 2),
                                  (_ctx.visibilityQuestionaire)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                        _hoisted_137,
                                        _createElementVNode("div", _hoisted_138, [
                                          (singlemodule.questionaireScreensArray)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlemodule.questionaireScreensArray, (questionairescreen) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "accordion-head text-black no-underline mt-3 min-h-3",
                                                    key: questionairescreen,
                                                    id: "screendata"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_140, _toDisplayString(questionairescreen.questionaireName), 1)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_141, _hoisted_143))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(JSON.stringify(singlemodule) != JSON.stringify(_ctx.dummyMoudleObject) || _ctx.fileNameMod[smIndex] ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                onClick: ($event: any) => (_ctx.resetData(singlemodule,smIndex,$event))
                              }, "Reset", 10, _hoisted_146)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", null, [
                                (!singlemodule._id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(JSON.stringify(singlemodule) != JSON.stringify(_ctx.dummyMoudleObject) ||_ctx.fileNameMod[smIndex]  ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.actionModule(smIndex, _ctx.courses, singlemodule))
                                      }, "Save", 10, _hoisted_148)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(singlemodule._id && JSON.stringify(singlemodule) != JSON.stringify(_ctx.dummyMoudleObject)||_ctx.fileNameMod[smIndex] ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                        onClick: ($event: any) => (_ctx.actionModule(smIndex, _ctx.courses, singlemodule))
                                      }, "Update", 10, _hoisted_150)
                                    ]))
                              ])
                            ])
                          ])
                        ], 8, _hoisted_76)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.isloading)
              ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}